module.exports = __webpack_public_path__ + "static/media/2D.eaef1133.svg";